import { Paper, TableContainer } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../../Components/CustomEmptyView";
import DeleteConfirmationPopup from "../../../../Components/DeleteConfirmationPopup";
import TableTopView from "../../../../Components/TableTopView";
import Strings from "../../../../Config/Strings";
import { deleteUserAPI } from "../../../../Store/Action/UserAction";
import ManufacturesTableHeader from "../Controller/ManufactureTableHeader";
import ManufacturesTableBody from "../Controller/ManufactureTablebody";
import Icons from "../../../../Config/Images";
import Pagination from "../../../../Components/Pagination";
import Colors from "../../../../theme/Colors";

const ManufactureTable = ({
  manufacturesData,
  onViewManufacturesDetails,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  totalItems,
  rowsPerPageOptions,
  rowsPerPageLabel,
  searchValue,
  onSearchChange,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);

  const handleOpen = useCallback(() => setModalVisible(true), []);
  const handleClose = useCallback(() => setModalVisible(false), []);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const handleCancelDelete = useCallback(() => {
    setShowDeleteModal(false);
  }, []);

  const onEditManufacturesDetails = useCallback(
    (manufacture) => {
      navigate("/manufacturesList/edit", { state: { manufacture } });
    },
    [navigate]
  );

  const handleShowDeleteModal = (userId) => {
    setUserIdToDelete(userId);
    setShowDeleteModal(true);
  };

  const onAddManufactures = useCallback(() => {
    navigate("/addManufactures");
  }, [navigate]);

  const handleDeleteUser = async () => {
    try {
      await dispatch(
        deleteUserAPI(userIdToDelete, (isSuccess, response) => {
          setShowDeleteModal(false);
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message);
            setTimeout(() => {
              window.location.reload();
            }, 400);
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ height: "92%", minWidth: "110%" }}>
            {manufacturesData?.length === 0 ||
            manufacturesData?.length === undefined ||
            manufacturesData?.length === null ? (
              <div
                style={{
                  width: "70vw",
                }}
              >
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <ManufacturesTableHeader />
                  <ManufacturesTableBody
                    manufacturesData={manufacturesData}
                    onViewManufacturesDetails={onViewManufacturesDetails}
                    onEditManufacturesDetails={onEditManufacturesDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                  />
                </table>
              </>
            )}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  height: "100%",
  margin: "0px 8px",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
};

const tableWrapper = {
  overflowY: "scroll",
  overflowX: "scroll",
  height: "100%",
};

const table = {
  minWidth: "110%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default ManufactureTable;
